import { render, staticRenderFns } from "./ProductButtonPlay.vue?vue&type=template&id=0bea680a&scoped=true&"
import script from "./ProductButtonPlay.vue?vue&type=script&lang=js&"
export * from "./ProductButtonPlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductButtonPlay.vue?vue&type=style&index=0&id=0bea680a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea680a",
  null
  
)

export default component.exports